$(document).ready(function()
{

    if ( $('.js-slick').length )
    {
        $(".js-slick").slick({
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: true
        });
    }

    if ( $('.js-slick-auto').length )
    {
        $(".js-slick-auto").slick({
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: true
        });
    }

    if ( $('.js-background-video').length )
    {

        $(".js-background-video").each(function()
        {
            var playerContainer = $(this);

            if($(this).hasClass('youtube'))
            {
                $(this).YTPlayer({
                    videoId: $(this).data('video-id'),
                    playerVars: {
                        playlist: $(this).data('video-id'),
                        loop: 1
                    },
                    fitToBackground: false,
                    width: 	$(this).width(),
                    callback: function() {
                        $(playerContainer).addClass('js-remove-background')
                    }
                });
            };

        });

    }

});